module.exports = __webpack_public_path__ + "img/advantages_pc.4fb3c48.svg";